/**
 * RoutingArrangementIndicator
 * - Tag: 2883
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const RoutingArrangementIndicator = Object.freeze({
    /** No routing arrangement in place */
    NoRoutingArrangementInPlace: 0,
    /** Routing arrangement in place */
    RoutingArrangementInPlace: 1,
} as const);

export type RoutingArrangementIndicator =
    (typeof RoutingArrangementIndicator)[keyof typeof RoutingArrangementIndicator];
